export enum BrandSegment {
  POWERED_BY_SONDER = "Powered By Sonder",
  HOTEL = "Sonder Hotel",
}
export const DescriptionTypeOptions = ["singular", "plural"] as const;

export type DescriptionType = typeof DescriptionTypeOptions[number];
